export default "__VITE_ASSET__6Wa2AtK$__"